module.exports = __webpack_public_path__ + "img/Logo-dark.030c8fb2.png";